import { EpgResponse, RequestTrackingByOrderParams } from "../types/tracking"

const orderMock = (epg: EpgResponse, params: RequestTrackingByOrderParams) => {
    return {
        cantPaginas: 0,
        filasPorPagina: 0,
        codigoPais: 'CO',
        listEstadoPedido: [],
        pedido: {
            id: Number(params.id),
            bultosPorPedido: 0,
            consultora: {
                id: 0,
                nombre: null,
                celular: null,
                direccion: null
            },
            nombreTransportista: null,
            comentarioTransportista: null,
            pathEntregaFallida: null,
            pathRemito: null,
            nombreRecibio: null,
            dniRecibio: null,
            fecha: epg.date,
            fechaEntrega: null,
            fechaEntregaHasta: null,
            fechaEntregaFueModificada: null,
            fechaEvento: null,
            tieneHijos: false,
            idPadre: null,
            idEvento: 0,
            idCategoriaEvento: 0,
            tipoDeEntrega: null,
            detalleDeEntrega: "",
            idTransportista: 0,
            numeroGuia: null,
            idPedidoReemplazante: null,
            direccionConsultora: null,
            partido: null,
            localidad: null,
            provincia: null,
            nombreVisualizacionConsultoraEvento: "test",
            eventoTipoFinalizacionTracking: false
        }
    }
}

export default orderMock